<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Calendario de embarques</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
        <b-col class="text-right">
          <template v-for="(plant, pInx) in plants">
            <span :key="pInx"><i class="fa fa-square" :style="'color: ' + plant.color"></i> {{ plant.name }}</span>
            <br />
          </template>
        </b-col>
      </b-row>
      <modal-shipment-info :selectedShipment="selectedShipment" />
      <b-row>
        <b-col>
          <div class="demo-app">
            <div class="demo-app-main">
              <FullCalendar class="demo-app-calendar" :options="calendarOptions" v-if="ready">
                <template v-slot:eventContent="arg">
                  <b>{{ arg.timeText }}</b>
                  <i>{{ arg.event.title }}</i>
                </template>
              </FullCalendar>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import ModalShipmentInfo from "./ModalShipmentInfo.vue";

const colors = ["#073b4c", "#118ab2", "#06d6a0", "#ef476f", "#ffd166"];
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    ModalShipmentInfo
  },

  data: function () {
    return {
      ready: false,
      plants: [],
      shipments: [],
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        // Monday first day of week
        firstDay: 1,
        // Spanish
        locale: "es",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay"
        },
        initialView: "dayGridMonth",
        eventDisplay: "block",
        initialEvents: [
          {
            id: 1,
            title: "Event Now",
            start: "2023-01-08"
          }
        ], // alternatively, use the `events` setting to fetch from a feed
        eventTimeFormat: {
          hour: "numeric",
          minute: "2-digit",
          omitZeroMinute: true,
          meridiem: "short",
          hour12: false
        },
        // editable: true,
        // selectable: true,
        // selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // select: this.handleDateSelect,
        eventClick: this.handleEventClick
        // eventsSet: this.handleEvents
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      selectedShipment: null
    };
  },
  mounted() {
    this.fetchShipment();
  },
  methods: {
    getStatus(value) {
      switch (value) {
        case 1:
          return "Programado";
        case 2:
          return "Despachado";
        case 3:
          return "Nulo";
        case 4:
          return "Pre embarque";
        case 5:
          return "Reparar precios";
        case 6:
          return "Liquidado";
        default:
          return "Desconocido";
      }
    },
    fetchShipment() {
      this.loading = true;
      this.$axios
        .get(
          `/api/comex/shipment/?limit=15&expand=plant&fields=boarding_number,id,shipment_date,plant.name,shipment_status`
        )
        .then((response) => {
          this.shipments = response.data.results;
          // Map not repeated plants {name, color}
          this.plants = this.shipments
            .map((shipment) => shipment.plant.name)
            .filter((plant, index, self) => self.indexOf(plant) === index)
            .map((plant, index) => ({ name: plant, color: colors[index] }));

          this.calendarOptions.initialEvents = response.data.results.map((shipment) => ({
            id: shipment.id,
            title: shipment.boarding_number + " - " + this.getStatus(shipment.shipment_status),
            start: shipment.shipment_date,
            // Color by plant
            color: this.plants.find((plant) => plant.name === shipment.plant.name).color
          }));
          this.loading = false;
          this.ready = true;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
    },

    // handleDateSelect(selectInfo) {
    //   let title = prompt("Please enter a new title for your event");
    //   let calendarApi = selectInfo.view.calendar;

    //   calendarApi.unselect(); // clear date selection

    //   if (title) {
    //     calendarApi.addEvent({
    //       id: createEventId(),
    //       title,
    //       start: selectInfo.startStr,
    //       end: selectInfo.endStr,
    //       allDay: selectInfo.allDay
    //     });
    //   }
    // },

    handleEventClick(clickInfo) {
      this.selectedShipment = clickInfo.event.id;
      this.$nextTick(() => {
        this.$bvModal.show("shipment_info_modal");
      });
    },

    handleEvents(events) {
      this.currentEvents = events;
    }
  }
};
</script>

<style lang="css">
h2 {
  margin: 0;
  font-size: 16px;
}

ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}

b {
  /* used for event dates/times */
  margin-right: 3px;
}

.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}

.demo-app-sidebar-section {
  padding: 2em;
}

.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}

.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>
